import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchInvoices = createAsyncThunk(
  'billing/fetchInvoices',
  async (_, { extra: { sdk } }) => {
    const { data } = await sdk.users.fetchInvoices();
    return Array.isArray(data) ? data : [];
  },
  {
    condition: (_, { getState }) => {
      const { invoices, invoicesLoading } = getState().billing;
      return invoices === null && !invoicesLoading;
    },
  },
);

/* eslint-disable no-param-reassign */
export const reducer = (builder) => {
  builder
    .addCase(fetchInvoices.pending, (state) => {
      state.invoicesLoading = true;
      state.invoicesError = false;
    })
    .addCase(fetchInvoices.fulfilled, (state, { payload }) => {
      state.invoicesLoading = false;
      state.invoicesError = false;
      state.invoices = payload;
    })
    .addCase(fetchInvoices.rejected, (state) => {
      state.invoicesLoading = false;
      state.invoicesError = true;
      state.invoices = null;
    });
};
/* eslint-enable no-param-reassign */
